import { useEffect, useState } from 'react';
import { ArrowUpRight, Shirt } from 'lucide-react';
import { Reveal, SectionLabel } from '../components/Common';
import { ScrollCard } from '../components/ScrollCard';
import { ShopDialog } from '../components/ShopDialog';
import { shopIntro, shopProducts } from '../shopData';
import { useUI } from '../context/UIContext';
import '../styles/shop.css';

export const Shop = () => {
  const { lenis } = useUI();
  const [product, setProduct] = useState(null);
  useEffect(() => { if (product) lenis.current?.stop(); else lenis.current?.start(); }, [product, lenis]);

  return <>
    <main id="content" className="shop-page">
      <section className="shop-hero section-pad" data-testid="shop-hero">
        <SectionLabel number="02" id="shop">{shopIntro.eyebrow}</SectionLabel>
        <div className="shop-hero-grid">
          <Reveal className="shop-hero-copy">
            <h1 className="display-heading shop-title" data-testid="shop-title" aria-label={`${shopIntro.title[0]} ${shopIntro.title[1]}`}>{shopIntro.title[0]}<br /><em>{shopIntro.title[1]}</em></h1>
            <p className="shop-subtitle">{shopIntro.subtitle}</p>
            <p className="shop-intro" data-testid="shop-intro">{shopIntro.intro}</p>
          </Reveal>
          <Reveal className="shop-hero-art" delay={0.12}><Shirt className="shop-hero-icon" strokeWidth={0.8} aria-hidden="true" /></Reveal>
        </div>
      </section>
      <section className="shop-catalog" data-testid="shop-section">
        <div className="shop-grid">
          {shopProducts.map((item, i) => <ScrollCard key={item.id} index={i}>
            <button className="shop-card" onClick={() => setProduct(item)} data-testid={`shop-product-${item.id}`}>
              <div className="shop-card-head"><span className="shop-card-label">{item.name}</span><span className="shop-card-dash" /></div>
              <div className="shop-card-photo"><img src={item.image} alt={item.name} loading="lazy" /></div>
              <div className="shop-card-foot"><span className="shop-card-type">{item.type}</span><ArrowUpRight size={20} strokeWidth={1.5} /></div>
            </button>
          </ScrollCard>)}
        </div>
      </section>
    </main>
    <ShopDialog product={product} onClose={() => setProduct(null)} />
  </>;
};
